import { IJobApplication, isFirstStepInProcess } from '../../../common';
import StepNewTemplate from './StepNewTemplate';
import StepInitialTemplate from './StepInitialTemplate';

interface StepsTemplateProps {
    jobApplicationData: IJobApplication;
}

const StepsTemplate = (props: StepsTemplateProps) => {
    const { jobApplicationData } = props;

    const _isFirstStepInProcess = isFirstStepInProcess(jobApplicationData);

    if (_isFirstStepInProcess) {
        return <StepNewTemplate jobApplicationData={jobApplicationData} />;
    }

    return <StepInitialTemplate jobApplicationData={jobApplicationData} />;
};

export default StepsTemplate;
